// TODO: Replace later with real data
export enum Country {
    /** Andorra */
    AD = 'AD',
    /** Albania */
    AL = 'AL',
    /** Austria */
    AT = 'AT',
    /** Bosnia and Herzegovina */
    BA = 'BA',
    /** Belgium */
    BE = 'BE',
    /** Bulgaria */
    BG = 'BG',
    /** Belarus */
    BY = 'BY',
    /** Switzerland */
    CH = 'CH',
    /** Cyprus */
    CY = 'CY',
    /** Czech Republic */
    CZ = 'CZ',
    /** Germany */
    DE = 'DE',
    /** Denmark */
    DK = 'DK',
    /** Estonia */
    EE = 'EE',
    /** Spain */
    ES = 'ES',
    /** Finland */
    FI = 'FI',
    /** France */
    FR = 'FR',
    /** United Kingdom */
    GB = 'GB',
    /** Greece */
    GR = 'GR',
    /** Croatia */
    HR = 'HR',
    /** Hungary */
    HU = 'HU',
    /** Ireland */
    IE = 'IE',
    /** Iceland */
    IS = 'IS',
    /** Italy */
    IT = 'IT',
    /** Liechtenstein */
    LI = 'LI',
    /** Lithuania */
    LT = 'LT',
    /** Luxembourg */
    LU = 'LU',
    /** Latvia */
    LV = 'LV',
    /** Monaco */
    MC = 'MC',
    /** Moldova */
    MD = 'MD',
    /** Montenegro */
    ME = 'ME',
    /** North Macedonia */
    MK = 'MK',
    /** Malta */
    MT = 'MT',
    /** Netherlands */
    NL = 'NL',
    /** Norway */
    NO = 'NO',
    /** Poland */
    PL = 'PL',
    /** Portugal */
    PT = 'PT',
    /** Romania */
    RO = 'RO',
    /** Serbia */
    RS = 'RS',
    /** Russia */
    RU = 'RU',
    /** Sweden */
    SE = 'SE',
    /** Slovenia */
    SI = 'SI',
    /** Slovakia */
    SK = 'SK',
    /** San Marino */
    SM = 'SM',
    /** Turkey */
    TR = 'TR',
    /** Ukraine */
    UA = 'UA',
    /** Vatican City */
    VA = 'VA',
}
